"use strict";

(function (H) {
	H.wrap(H.Chart.prototype, 'dkZoom', function (proceed, type, ieChart) {

		if (!!ieChart) {
			ieChart.tiny = null;
		}

		return ordinalZoom.apply(this, arguments);
	});

	function ordinalZoom(proceed, type) {
		var chart = this,
		    series = chart.series,
		    xAxis = chart.get('mainX'),
		    currentMin = xAxis.min,
		    currentMax = xAxis.max,
		    s = series[longestSeries(series)];

		var currentMinIndex = indexOfClosest(s.xData, currentMin),
		    currentMaxIndex = indexOfClosest(s.xData, currentMax, true),
		    indexDif = currentMaxIndex - currentMinIndex,

		//MIN AMOUNT YOU CAN ZOOM TO
		MIN_AMOUNT_ZOOM = 20;

		if (type == 'in' && indexDif <= MIN_AMOUNT_ZOOM || type == 'out' && indexDif >= s.xData.length - 1) {
			return;
		}

		//move 25% of currently displayed points
		var amountToMove = Math.ceil(indexDif * 0.10);

		var newMinIndex = currentMinIndex,
		    newMaxIndex = currentMaxIndex;
		if (type != 'reset') {
			if (type == 'in') {

				newMinIndex = newMinIndex + amountToMove;
				if (newMinIndex > currentMaxIndex - MIN_AMOUNT_ZOOM) {
					newMinIndex = currentMaxIndex - MIN_AMOUNT_ZOOM;
				}
			} else if (type == 'out') {

				newMinIndex = currentMinIndex - amountToMove;
				newMaxIndex = currentMaxIndex + amountToMove;

				if (newMinIndex < 0) {
					newMinIndex = 0;
				}
			}

			var newMin = s.xData[newMinIndex],
			    newMax = s.xData[newMaxIndex];

			for (var i = 0; i < chart.xAxis.length; i++) {
				var x = chart.xAxis[i];
				x.setExtremes(newMin, newMax);
			}
			//Missing update closeLine when zoom
			if(s.userOptions.compare == 'percent'){
				$(".iChart-plotLabel").html((x.chart.series[0].data[x.chart.series[0].data.length-1].change).toFixed(3));
			}
		} else {
			var x = chart.xAxis[0];
			x.setExtremes( chart.options.defaultZoom[0],  chart.options.defaultZoom[1] );
		}
	};

	function longestSeries(series) {
		var resultIndex = 0,
		    maxLength = -1;

		for (var i = 0; i < series.length; i++) {
			var this_length = series[i].data.length;

			if (this_length >= maxLength) {
				resultIndex = i;
				maxLength = this_length;
			}
		} //end for

		return resultIndex;
	};

	function indexOfClosest(arr, valToFind) {
		var startFromEnd = arguments.length <= 2 || arguments[2] === undefined ? false : arguments[2];

		if (!arr || !valToFind) {
			return -1;
		}

		if (startFromEnd) {
			for (var i = arr.length - 1; i >= 0; i--) {

				if (arr[i] <= valToFind) {
					return i;
				}
			}
		} else {
			for (var i = 0; i < arr.length; i++) {
				if (arr[i] >= valToFind) {
					return i;
				}
			}
		}
		return -1;
	};
})(Highcharts);

// SET DEFAULT ZOOM LEVEL
function defaultSetExtremes(forcedExtremes) {
	var _this = this,
	    chart = _this.chart,
	    series = chart.series,
	    xAxis = chart.xAxis,
	    min = null,
	    max = null;

	if (_this.isYield) {
		return;
	}

	if (forcedExtremes) {
		for (var i = 0; i < xAxis.length; i++) {
			var x = xAxis[i];
			x.setExtremes(forcedExtremes.min, forcedExtremes.max);
		}
		return;
	}

	var minX, maxX;
	for (var i = 0; i < series.length; i++) {

		var s = series[i];
		if (s.options.type == 'trendline') {
			continue;
		}
		if (s.options.type == 'flags') {
			continue;
		}

		var type = s.options.type; 

		//DEFAULT ZOOM VALUES
		var data = s.data.length >= 1 && s.data[0] ? s.data : s.xData,
			minIndex = type == 'area' && s.options.id != 'null:cur' || type == 'line' && s.options.id != 'null:cur' || type == 'candlestick' && s.options.id != 'null:cur' || type == 'ohlc' && s.options.id != 'null:cur'? data.length >= 171 ? 0 : 0 : data.length >= 51 && isFirstCall ? data.length -85 : data.length >= 51? data.length -75 : 0,
			maxIndex = data.length - 1;
			minX = data[minIndex] && data[minIndex].hasOwnProperty('x') ? data[minIndex].x: data[minIndex];
			maxX = data[maxIndex] && data[maxIndex].hasOwnProperty('x') ? data[maxIndex].x: data[maxIndex];

		if (min == null || minX < min) {
			min = minX;
		};

		if (max == null || maxX > max) {
			max = maxX;
		};
	}
	_this.chart.options['defaultZoom'] = [min, max];

	for (var i = 0; i < xAxis.length; i++) {
		var x = xAxis[i];
		x.setExtremes(min, max);
	}
	return;
};